import { render, staticRenderFns } from "./Homewatch.vue?vue&type=template&id=0a612082&scoped=true&"
import script from "./Homewatch.vue?vue&type=script&lang=js&"
export * from "./Homewatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a612082",
  null
  
)

export default component.exports